import { useState } from "react";
import { Mail, Check } from "lucide-react";

/* ============================================================
   Newsletter signup
   ============================================================
   This is a stub. Wire it up to your Supabase:
   
   1. Create table: newsletter_subscribers (id, email, created_at, source)
   2. RLS policy allowing inserts from anon
   3. Replace handleSubmit body with:
   
      const { error } = await supabase
        .from('newsletter_subscribers')
        .insert({ email, source: window.location.pathname });
      if (!error) setStatus('success');
   
   Or use a simple Netlify Form, ConvertKit, or Buttondown.
   ============================================================ */

export default function NewsletterSignup({
  title = "Receba atualizações úteis",
  subtitle = "Sem spam. Sem corrente. Só quando há ferramenta nova ou mudança importante.",
}) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setStatus("loading");
    
    // TODO: replace with actual Supabase insert
    await new Promise((r) => setTimeout(r, 600));
    setStatus("success");
  };

  return (
    <div className="border border-border rounded-2xl p-6 md:p-8 bg-surface my-12">
      <div className="flex items-start gap-3 mb-4">
        <Mail size={20} className="text-accent shrink-0 mt-1" />
        <div>
          <h3 className="font-serif text-2xl font-medium leading-tight mb-1">
            {title}
          </h3>
          <p className="text-sm text-ink-soft leading-relaxed">{subtitle}</p>
        </div>
      </div>
      {status === "success" ? (
        <div className="flex items-center gap-2 text-success font-medium">
          <Check size={18} />
          Pronto. Obrigado!
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex gap-2 flex-col sm:flex-row mt-4">
          <input
            type="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 border-2 border-border rounded-xl px-4 py-3 bg-bg text-ink outline-none focus:border-accent transition-colors"
            required
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="bg-ink text-bg px-6 py-3 rounded-xl font-semibold whitespace-nowrap hover:bg-ink/90 transition-colors disabled:opacity-50"
          >
            {status === "loading" ? "Enviando..." : "Inscrever"}
          </button>
        </form>
      )}
    </div>
  );
}
